<template>
  <div>
    <div class="user1"></div>
    <div class="user">
      <el-form ref="elForm" inline>
        <el-form-item>
          <el-input v-model="query.name_or_phone" @keyup.enter.native="handleCurrentChange(1)" placeholder="请输入用户名称或手机号"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCurrentChange(1)" v-if="JudgeButton(role_permission,'user/query')"
            icon="el-icon-search"> 查询 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="close1" v-if="JudgeButton(role_permission,'user/increase')"
            icon="el-icon-circle-plus"> 新增 </el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="!multipleSelection.length" type="danger" icon="el-icon-milk-tea"
            v-if="JudgeButton(role_permission,'user/delete')" @click="handleDelete1"> 删除 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="user2" style="width: 90%" v-loading='loading'>
      <el-table stripe border ref="multipleTable" :data="tableData" tooltip-effect="dark"
        @selection-change="handleSelectionChange">
        <el-table-column align='center' type="selection" width="55">
        </el-table-column>

        <el-table-column align='center' label="用户名称" width="150">
          <template slot-scope="scope">{{ scope.row.name}}</template>
        </el-table-column>

        <el-table-column align='center' label="性别" width="80">
          <template slot-scope="scope">{{ scope.row.sex | isSex }}</template>
        </el-table-column>

        <el-table-column align='center' prop="phone" label="手机号" width="130" show-overflow-tooltip>
        </el-table-column>


        <el-table-column align='center' prop="role_name" label="角色" width="180" show-overflow-tooltip>
        </el-table-column>

        <el-table-column align='center' prop="area_id" label="区域" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="操作" align='center' width="280">

          <template slot-scope="scope">
            <el-button size="mini" type="primary" v-if="JudgeButton(role_permission,'user/reset')"
              @click="hanReset(scope.$index, scope.row)">重置密码</el-button>
            <el-button size="mini" type="primary" v-if="JudgeButton(role_permission,'user/edit')"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" v-if="JudgeButton(role_permission,'user/delete')"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="user3" style="margin: 30px auto;text-align: center;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
          :page-sizes="[10, 30, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
          :total="count">
        </el-pagination>
      </div>
    </div>





    <el-dialog :title="title" :visible.sync="dialogVisible" v-el-drag-dialog width="40%" @close='close'>
      <el-row :gutter="5">
        <el-form ref="added" :model="formData1" :rules="rules1" size="medium" label-width="160px">
          <el-col :span="12">
            <el-form-item label="用户名：" prop="field101">
              <el-input v-model="formData1.field101" placeholder="请输入用户名" :maxlength='15' show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item label="性别：" prop="field105">
              <el-radio-group v-model="formData1.field105" size="medium">
                <el-radio v-for="(item, index) in field105Options" :key="index" :label="item.value"
                  :disabled="item.disabled">{{item.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="field106">
              <el-input type="number"
                @input="formData1.field106=formData1.field106.length > 11?formData1.field106.slice(0, 11):formData1.field106"
                v-model="formData1.field106" placeholder="请输入手机号">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="角色：" prop="field118">
              <el-radio-group v-model="formData1.field118" size="medium">
                <el-radio style="margin-top: 10px;margin-bottom: 20px;" v-for="(i,l) in field118Options"
                  :disabled='i.role_name==="admin"?true:false' :key="l" :label="i.role_id">{{i.role_name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="区域选择" prop="field119">
              <el-select v-model="formData1.field119" placeholder="请选择" clearable :style="{width: '100%'}">
                <el-option v-for="(item, index) in field119Options" :key="index" :label="item.area_name"
                  :value="item.area_id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handelConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import elDragDialog from "@/utils/el-dragDialog";
  import userInfoAPI from '@/api/api';
  export default {
    name: 'userManage',
    props: {},
    data() {
      var validatorPhone = function(rule, value, callback) {
        if (!/^1[23456789]\d{9}$/.test(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      return {
        count: 0,
        title: "", //弹窗title
        dialogVisible: false, //弹窗 ture false
        multipleSelection: [], //是否全选框框
        tableData: [],
        formData1: { //弹窗 内容
          field101: undefined,
          field105: undefined,
          field106: undefined,
          field118: undefined,
          field119: undefined,
          id: undefined
        },
        rules1: { //弹窗 正则
          field101: [{
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }],
          field105: [{
            required: true,
            message: '性别不能为空',
            trigger: 'change'
          }],
          field106: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }, {
            message: '手机号格式有误',
            validator: validatorPhone,
            trigger: 'blur'
          }],
          field118: [{
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }],
          field119: [{
            required: true,
            message: '请选择区域',
            trigger: 'change'
          }],
        },
        field105Options: [{ //弹窗
          "label": "男",
          "value": 1
        }, {
          "label": "女",
          "value": 2
        }],
        field118Options: [],
        field119Options: [],
        loading: true,
        query: {
          name_or_phone: "",
          page_limit: 10,
          page: 1
        }
      }
    },
    watch: {},
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      },
      routesData() {
        return this.routes
      }
    },
    directives: {
      elDragDialog,
    },
    created() {
      if (this.$store.state.cache.cacheUserQuery) this.query = this.$store.state.cache.cacheUserQuery
      this.init2();
    },
    beforeDestroy() {
      this.$store.commit('CACHE_USER', this.query)
    },
    methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      init() {
        this.loading = true
        userInfoAPI.systemUser(this.query).then(({
          data
        }) => {
          if (data.code == 0) {
            this.count = data.data.page.count * 1;
            this.tableData = data.data.list;
            this.init1();
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
          this.loading = false
        })
      },
      init1() {
        this.tableData.forEach(i => {
          var area_id = i.area_id;
          if (area_id == 0) {
            i.area_id = '超级管理员不分区域'
          } else {
            this.field119Options.forEach(l => {
              if (area_id == l.area_id) {
                i.area_id = l.area_name
              }
            })

          }
        })
      },
      init2() {
        let role_id = ''
        userInfoAPI.adminRole(role_id).then(({
          data
        }) => {
          if (data.code == 0) {
            this.field118Options = data.data.list;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
          this.init();
        })
        let area_id = ''
        userInfoAPI.createArea3(area_id).then(({
          data
        }) => {
          if (data.code == 0) {
            this.field119Options = data.data.list;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.init();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.init();
      },
      handleSelectionChange(val) { //是否全选框框
        this.multipleSelection = val;
      },
      hanReset(index, row) {
        userInfoAPI.adminUserResetPwd(row.uid).then(({
          data
        }) => {
          if (data.code == 0) {
            this.$message({
              showClose: true,
              message: '密码成功重置为：123456',
              type: 'success'
            });
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        })
      },
      handleEdit(index, row) { //编辑
        this.title = '编辑用户：' + row.name;
        this.dialogVisible = true;
        this.formData1.field101 = row.name
        this.formData1.field105 = row.sex
        this.formData1.field106 = row.phone
        this.field118Options.forEach(i => {
          if (i.role_name == row.role_name) {
            this.formData1.field118 = i.role_id
          }
        })
        this.field119Options.forEach(i => {
          if (i.area_name == row.area_id) {
            this.formData1.field119 = i.area_id
          }
        })
        this.formData1.id = row.uid;
      },
      handleDelete(index, row) { //删除
        this.$confirm('是否确定删除该用户?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.systemUser4(row.uid).then(({
            data
          }) => {
            if (data.code == 0) {
              this.init();
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        })
      },
      handleDelete1() {
        this.$confirm('是否确定删除该用户?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.systemUser4(this.multipleSelection.map(i => {
            return i.uid
          }).join(',')).then(({
            data
          }) => {
            if (data.code == 0) {
              this.init();
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        })
      },
      handleClose(done) { //弹窗关闭回调
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      close1() {
        this.formData1.field101 = undefined;
        this.formData1.field105 = undefined;
        this.formData1.field106 = undefined;
        this.formData1.field118 = undefined;
        this.formData1.field119 = undefined;
        this.formData1.id = undefined;
        this.dialogVisible = true;
        this.title = '新增'
      },
      close() { //弹窗关闭
        this.$refs['added'].resetFields(); //强制清理表格内容 
        this.dialogVisible = false;
      },
      handelConfirm() { //弹窗确认功能按钮
        var that = this;
        this.$refs['added'].validate(valid => {
          if (valid) {
            setTimeout(() => {
              if (that.title == '新增') {
                userInfoAPI.systemUser2({
                  name: that.formData1.field101,
                  sex: that.formData1.field105,
                  phone: that.formData1.field106,
                  role_id: that.formData1.field118,
                  area_id: that.formData1.field119,
                }).then(({
                  data
                }) => {
                  if (data.code == 0) {
                    that.close();
                    that.init();
                    that.$message({
                      showClose: true,
                      message: data.msg,
                      type: 'success'
                    });
                  } else {
                    that.$message({
                      showClose: true,
                      message: data.msg,
                      type: 'error'
                    });
                  }
                }).catch((err) => {

                });
              } else {
                userInfoAPI.systemUser3({
                  name: that.formData1.field101,
                  sex: that.formData1.field105,
                  phone: that.formData1.field106,
                  role_id: that.formData1.field118,
                  area_id: that.formData1.field119,
                }, that.formData1.id).then(({
                  data
                }) => {
                  console.log(data, 'datadatadata')
                  if (data.code == 0) {
                    that.close();
                    that.init();
                    that.$message({
                      showClose: true,
                      message: data.msg,
                      type: 'success'
                    });
                  } else {
                    that.$message({
                      showClose: true,
                      message: data.msg,
                      type: 'error'
                    });
                  }
                }).catch((err) => {

                });
              }
            }, 600)

          }
        })
      }
    }
  }
</script>
<style lang='scss' scoped>
  /deep/.el-dialog__title {
    color: #fff;
  }

  /deep/ .el-dialog__header {
    background-color: rgb(62, 62, 238);
  }

  /deep/ .el-dialog__headerbtn {
    i {
      color: #fff;
    }
  }

  .user {
    margin-bottom: 20px;

    .el-form-item {
      margin-left: 20px;
    }
  }

  .user2 {
    margin-left: 20px;
    margin-bottom: 20px;
  }

  .user1 {
    height: 20px;
  }
</style>
